// @flow strict

export const heroEnterAnimationDuration = 1100;
export const heroExitAnimationDuration = 450;
export const heroDesktopHeight = 480;
export const heroMobileHeight = 288;
